import { useTranslations } from "next-intl";

import { LoadingSpinner } from "~/components/loading-spinner";
import { Button } from "~/components/ui/button";
import { type ProductId } from "~/lib/tours";
import { useTrack } from "~/lib/use-track";
import { usePathname } from "~/navigation";

export function TourBookingAddToBag({
  loading,
  productId,
  datoTourId,
  onClick,
}: {
  loading: boolean;
  productId: ProductId;
  datoTourId: string;
  onClick: () => void;
}) {
  const track = useTrack();
  const pathname = usePathname();
  const t = useTranslations("Checkout");

  return (
    <Button
      className="w-full text-base"
      size="lg"
      type="submit"
      variant="sunset"
      onClick={(event) => {
        event.preventDefault();
        onClick();
        track({
          name: "Add To Cart",
          type: productId.type,
          datoTourId,
          pathname,
        });
      }}
      disabled={loading}
    >
      <div className="inline-flex items-center gap-2">
        {loading ? <LoadingSpinner /> : null}
        {t("confirm")}
      </div>
    </Button>
  );
}
